import { Outlet } from "react-router-dom";

import {
  BubbleChart,
  CompareArrows,
  Person,
  QueryStats,
  RocketLaunch,
  UploadFile,
} from "@mui/icons-material";

import { AppContainer, AuthContainer } from "@/components/containers";
import { DialogRoot } from "@/components/molecules";
import {
  ActivationProvider,
  AudienceProvider,
  CompareProvider,
  SnackbarProvider,
  DialogProvider,
  ViewModeProvider,
} from "@/context";
import { Navigation } from "@/types";

const NAVIGATION: Navigation = [
  {
    segment: "audience",
    title: "Audiences",
    icon: <Person />,
    pattern: "audience/:id?/:segment?",
  },
  {
    segment: "upload",
    title: "Upload",
    icon: <UploadFile />,
    pattern: "upload/:id?/:segment?",
  },
  {
    segment: "mindset",
    title: "Mindsets",
    icon: <BubbleChart />,
    pattern: "mindset/:id?/:segment?",
  },
  {
    segment: "activation",
    title: "Activation",
    icon: <RocketLaunch />,
    pattern: "activation/:id?/:segment?",
  },
  {
    segment: "compare",
    title: "Compare",
    icon: <CompareArrows />,
    pattern: "compare/:audienceIds?",
  },
  {
    segment: "measurement",
    title: "Measurement",
    icon: <QueryStats />,
  },
  // {
  //   segment: 'explore',
  //   title: 'Explore',
  //   icon: <Explore />,
  // },
];

function App() {
  return (
    <AuthContainer>
      <SnackbarProvider>
        <DialogProvider>
          <ViewModeProvider>
            <AudienceProvider>
              <CompareProvider>
                <ActivationProvider>
                  <AppContainer navigation={NAVIGATION}>
                    <Outlet />
                    <DialogRoot />
                  </AppContainer>
                </ActivationProvider>
              </CompareProvider>
            </AudienceProvider>
          </ViewModeProvider>
        </DialogProvider>
      </SnackbarProvider>
    </AuthContainer>
  );
}

export default App;
